import { createObservableDataAction, IActionContext, IAction, ICreateActionContext, IGeneric, IAny, ICommerceApiSettings } from '@msdyn365-commerce/core';
import { CacheType, callActionOrExecute, Customer, Address, DataServiceQuery, IActionInput, IDataServiceRequest } from "@msdyn365-commerce/retail-proxy";
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';

export class GetOrganizationCustomerAddressInput implements IActionInput {
    private readonly user: string | undefined;
    private readonly query: DataServiceQuery;

    constructor(apiSettings: ICommerceApiSettings, user: string) {
        this.user = user;

        this.query = new DataServiceQuery();
    }

    public getDataServiceRequest = (): IDataServiceRequest => {
        return this.query.createDataServiceRequestForOperation(
            'GetOrganizationCustomer',
            false,
            Entities.CustomerClass,
            'false',
            {
                bypassCache: 'get',
                returnEntity: 'Entities.CustomerClass'
            },
            {}
        );
    };

    public shouldCacheOutput = (): boolean => false;

    public getCacheKey = () => `OrganizationCustomerAddress-${this.user}`;
    public getCacheObjectType = () => 'OrganizationCustomer';
    public dataCacheType = (): CacheType => 'request';
}

const createGetAddressInput = (inputData: ICreateActionContext<IGeneric<IAny>>): GetOrganizationCustomerAddressInput => {
    const { user } = inputData.requestContext;
    return new GetOrganizationCustomerAddressInput(inputData.requestContext.apiSettings, user.customerAccountNumber ?? "");
};

export const getOrganizationCustomerAddressAction = async (input: GetOrganizationCustomerAddressInput, ctx: IActionContext): Promise<Address[]> => {
    if (!ctx.requestContext.user.isAuthenticated) {
        return [];
    }
    var customer = await callActionOrExecute<Customer>(input.getDataServiceRequest(), ctx);
    return customer.Addresses || [];
};

export const getOrganizationCustomerAddress = createObservableDataAction<Address[]>({
    id: '@msdyn365-commerce-modules/retail-actions/get-address',
    action: <IAction<Address[]>>getOrganizationCustomerAddressAction,
    input: <(args: ICreateActionContext) => IActionInput>createGetAddressInput
});

export default getOrganizationCustomerAddress;
